<template>
  <div class="home">
    <Hero
      title="Faça parte da transformação de vidas e empresas por meio da atividade física."
      :image="'foto-hero-home.jpg'"
      height="75vh"
      :search="true"
    />
    <WhoWeAre />
    <Faq />
  </div>
</template>

<script>
//Components
import Hero from "@/components/media/Hero.vue";
import Faq from "@/components/Faq.vue";
import WhoWeAre from "@/views/home/components/WhoWeAre.vue";
export default {
  name: "Home",
  data() {
    return {};
  },
  head() {
    return this.$head({
      title: "",
    });
  },
  mounted() {
    this.$store.dispatch("opportunities/setOpportunities");
  },
  components: {
    Hero,
    Faq,
    WhoWeAre,
  },
  computed: {},
};
</script>

